export default __webpack_public_path__ + "static/media/BlackJack.444194b7.gif";